 
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import FlexProfessionalInformation from './FlexProfessionalInformation';
import { useGetProfessionalQuery } from '../../../redux/managementCompanyWorkforce';
import FlexProfessionalNotes from './FlexProfessionalNotes';
import IsAuthorizedForManagementCompany from '../../../components/IsAuthorizedForManagementCompany/IsAuthorizedForManagementCompany';
import Permissions from '../../../constants/Permissions';
import { showNotification } from '../../../redux/notification';
import { setPreventNavigation, setLeaveConfirmationCopy } from '../../../redux/navigate';

import '../../../components/professionals/ProfessionalsEmployeeDetails.scss';
import './FlexProfessionalNotes.scss';

const LEAVE_CONFIRMATION_COPY = {
	title: 'Leave without saving changes?',
	message: 'None of the changes you have made will be saved if you leave now.',
	confirmLabel: 'Leave anyway',
	cancelLabel: 'Stay on page'
};

const FlexProfessionalsEmployeeDetails = ({ onEditModeChange }) => {
	const dispatch = useDispatch();
	const history = useHistory();

	const { professionalId: caregiverId, managementCompanyId } = useParams();
	const { data: professional, isFetching, error } = useGetProfessionalQuery(
		{ managementCompanyId, caregiverId },
		{
			refetchOnMountOrArgChange: true
		}
	);

	const [isProfileDirty, setIsProfileDirty] = useState(false);
	const [isNotesDirty, setIsNotesDirty] = useState(false);

	useEffect(() => {
		if (error) {
			const message = error.data && error.data.errors && error.data.errors[0] && error.data.errors[0].message;
			dispatch(showNotification('error', message || 'Professional is not enabled for flex'));
			history.goBack();
		}
	}, [error]);

	useEffect(() => {
		dispatch(setLeaveConfirmationCopy(LEAVE_CONFIRMATION_COPY));
		dispatch(setPreventNavigation(isProfileDirty || isNotesDirty));
		return () => {
			dispatch(setPreventNavigation(false));
			dispatch(setLeaveConfirmationCopy(null));
		};
	}, [isProfileDirty, isNotesDirty, dispatch]);

	return (
		<div className="flex-professional-employee-details">
			<FlexProfessionalInformation
				professional={professional}
				isFetching={isFetching}
				managementCompanyId={managementCompanyId}
				caregiverId={caregiverId}
				onEditModeChange={onEditModeChange}
				onDirtyChange={setIsProfileDirty}
			/>
			<IsAuthorizedForManagementCompany
				exactPermission={Permissions.WORKFORCE_NOTES_VIEW}
				managementCompanyId={managementCompanyId}
			>
				<FlexProfessionalNotes
					managementCompanyId={managementCompanyId}
					caregiverId={caregiverId}
					caregiverName={`${professional ? professional.first_name : ''} ${professional ? professional.last_name : ''}`}
					onDirtyChange={setIsNotesDirty}
				/>
			</IsAuthorizedForManagementCompany>
		</div>
	);
};

export default FlexProfessionalsEmployeeDetails;
